<template>
    <div class="contactUs">
        <linkUs tabIndex="1"></linkUs>
        <div :class="isMobile?'mobileShow':'linkBox'">
            <div>
                <p class="title">公司地址</p>
                <p>河北省石家庄市建设南大街269号河北师范大学科技园B座11、12层</p>
            </div>
            <div :style="`${isMobile?'':'margin-left:100px'}`">
                <p class="title">联系电话</p>
                <p>+86-0311-69052085/69052075</p>
            </div>
        </div>
        <div :class="isMobile?'mapBoxs':'mapBox'">
            <div class="mapImg">
                <img :src="location" alt="">
            </div>
            
            <!-- <baidu-map class="bm-view" ak="rRPAWpZS6LtuQGEeE1yTC1HcbmNLN8lF" :center="center" :zoom="zoom" :style="`${isMobile?'width:100%;height:300px;':'width:1200px;height:380px'}`">
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
                    <bm-overlay
                        pane="labelPane"
                        :class="{sample: isMobile?false:true,samples:isMobile?true:false, active}"
                        @mouseover.native="active = true"
                        @mouseleave.native="active = false">
                        <div>瑞和安惠项目管理集团有限公司</div>
                    </bm-overlay>
                </bm-marker>
            </baidu-map> -->
        </div>
    </div>
</template>

<script>
    import location from '@/assets/aboutUs/location.png'
    import linkUs from '@/components/linkUs'
	export default {
		name:'ContactUs',
        components:{linkUs},
        data() {
            return {
                center:{
                    lng:114.52044,
                    lat:38.00271 
                },
                zoom:20,
                active:true,
                location
            }
        },
        mounted(){
           
        }
	}
</script>

<style scoped lang="less">
    .linkBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 42px;
        display: flex;
        justify-content: flex-start;
        color: #000;
    }
    .mobileShow{
        width: 100%;
        color: #000;
    }
    .linkBox .title{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .mobileShow .title{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 15px;
        margin-top: 15px;
    }
    .mapBox{
        width: 1200px;
        height: 380px;
        margin: 0 auto;
        margin-top: 42px;
        margin-bottom: 42px;
    }
    .mapBoxs{
        width:calc(100% - 20px);
        height: 300px;
        margin: 0 auto;
        margin-top: 42px;
        margin-bottom: 42px;
    }
    .mapImg img{
        width: 100%;
    }
    .sample {
        width: 260px;
        height: 50px;
        line-height: 50px;
        background: #fff;
        border: 1px solid #e5e5e5;
        color: #333;
        text-align: center;
        position: absolute;
        margin-top: 95px;
        margin-left: 470px;
    }
    .samples {
        width: 260px;
        height: 50px;
        line-height: 50px;
        background: #fff;
        border: 1px solid #e5e5e5;
        color: #333;
        text-align: center;
        position: absolute;
        margin-top: 70px;
        margin-left: 200px;
    }
</style>